import { useState } from 'react';
import { deleteData } from '../../../../services/api/api-tools';
import { WarnModal } from '../pattern-panel/WarnModal';
import { useAlert } from '../../../../contexts/AlertContext';
import { AlertPanel } from './AlertPanel';
import { DashboardPanel } from './DashboardPanel';
import { Panel } from "../../../../components/panels/Panel";
import { ActionButton } from "../../../../components/buttons/ActionButton";
import { ArrowDownOnSquareIcon } from "@heroicons/react/20/solid";
import { downloadCsv, exportToCsv } from "../../../../helpers/file/csv-helper";
import { useJournal } from "../../../../contexts/JournalContext";
import { LOGS_TYPES } from "../../../../services/log/log-service";
import { addPatternExecutionsToLogs } from "../../../../services/entity/pattern/customer/lisi-pattern-service";

export const JournalRightPanel = () => {
  const { showAlert } = useAlert();
  const { logs, patternExecutions } = useJournal();

  const [alerts, setAlerts] = useState([]);
  const [alertIdToDelete, setAlertIdToDelete] = useState(null);

  const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);

  const onConfirmDeleteAlert = async (alertId) => {
    try {
      await deleteData('alerts', alertId);
      showAlert('success', 'The alert has been successfully deleted from the database.');
      setAlerts(alerts.filter((alert) => alert.id !== alertId));
    } catch (err) {
      console.error('Something bad happened:', err);
      showAlert('warning', 'Oops! Something went wrong while attempting to delete the target.');
    } finally {
      setIsWarnModalOpen(false);
      setAlertIdToDelete(null);
    }
  };

  const handleExportClick = () => {
    const enhancedLogs = addPatternExecutionsToLogs(logs.filter((log) => log.type === LOGS_TYPES.LOG1), patternExecutions);

    const csv = exportToCsv(
      enhancedLogs,
      [
        'date', 'hour', 'piece_id', 'process_name', 'oven_time', 'theoretical_oven_time', 'theoretical_oven_tolerance', 'oven_time_too_short',
        'oven_time_too_long', 'transfer_oven_hit_time', 'theoretical_transfer_oven_hit_time', 'theoretical_transfer_oven_hit_tolerance',
        'transfer_oven_hit_time_too_long', 'transfer_hit_cut_time', 'total_time', 'piece_ok', 'correct_bin'
      ],
      [
        'date', 'hour', 'piece_id', 'process_name', 'oven_time', 'theoretical_oven_time', 'theoretical_oven_tolerance', 'oven_time_too_short',
        'oven_time_too_long', 'transfer_oven_hit_time', 'theoretical_transfer_oven_hit_time', 'theoretical_transfer_oven_hit_tolerance',
        'transfer_oven_hit_time_too_long', 'transfer_hit_cut_time', 'total_time', 'piece_ok', 'correct_bin'
      ],
    );
    downloadCsv(csv, 'production_journal.csv');
  };

  return (
    <div className='flex flex-col w-full h-full'>
      <div className="h-1/2 flex flex-col">
        <div className="h-1/2">
          <Panel title="ACTIONS">
            <ActionButton text="Exporter (CSV)" Icon={ArrowDownOnSquareIcon} onClick={handleExportClick}/>
          </Panel>
        </div>
        <div className="h-1/2">
          <AlertPanel
            alerts={alerts}
            setAlerts={setAlerts}
            setIsWarnModalOpen={setIsWarnModalOpen}
            setAlertIdToDelete={setAlertIdToDelete}
          />
        </div>
      </div>
      <div className="h-1/2">
        <DashboardPanel/>
      </div>
      <WarnModal
        isOpen={isWarnModalOpen}
        setIsWarnModalOpen={setIsWarnModalOpen}
        onConfirmDelete={() => onConfirmDeleteAlert(alertIdToDelete)}
      />
    </div>
  );
};
